import { AsyncThunk } from '@reduxjs/toolkit';
import { AxiosResponse } from 'axios';

import { withMandant } from '../../../shared/thunks/with-mandant/with-mandant.thunk';
import { axiosInstance } from '../../shared/api/axios-instance';
import { createPathParams } from '../../shared/utils/create-path-params/create-path-params.util';
import { Endpoints } from '../../shared/utils/endpoints-file.utils';

export const getCampaignReportsTotalCount: AsyncThunk<
  number,
  number,
  Record<string, unknown>
> = withMandant<number, number>(
  Endpoints.GET_REPORTS_BY_CAMPAIGN_COUNT,
  'get-campaign-reports-total-count',
  async ({ args, endpoint }) => {
    const url = createPathParams<'campaignId'>(endpoint, {
      campaignId: args,
    });

    const { data }: AxiosResponse<number> = await axiosInstance.get(url);

    return data;
  }
);
